import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupMemberQuitContentProps } from './msg-group-member-quit-content';
import { MsgGroupMemberQuitContent } from './msg-group-member-quit-content';

export interface MsgGroupMemberQuitProps extends MsgGroupMemberQuitContentProps {}

export const MsgGroupMemberQuit = memo(function MsgGroupMemberQuit({
  message,
}: MsgGroupMemberQuitProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupMemberQuitContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
